exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2flTwl3T{padding:0;font-size:12px;line-height:16px;font-weight:700;letter-spacing:0;display:block}._23WE0d8p{padding:8px 0;margin:0;display:inline-block;width:100%}._3xyEhNvE ._1aH6CUx5{height:160px;display:inline-block;width:100%;background-size:contain;background-repeat:no-repeat}", ""]);

// exports
exports.locals = {
	"data-list-title": "_2flTwl3T",
	"data-list-container": "_23WE0d8p",
	"no-items-container": "_3xyEhNvE",
	"img-container": "_1aH6CUx5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/datalist/style.less
// module id = 1289
// module chunks = 1